let delegate_type_fields = ( function ( $ ) {

	let $select;

	let $other;

	let _init = function () {
		$select = $( '[name$="delegate_type"]' );

		console.log( $select );

		if ( $select.length > 0 ) {
			$other = $( 'div.field-wrap[id$="delegate_type_other"]' );

			// Set up the other wrap. Only need to do this as the bootstap hidden class uses !important
			$other.css( 'display', 'none' );
			$other.removeClass( 'hidden' );

			$select.on( 'change', e => _toggle_other_field() );
			_toggle_other_field();
		}
	};

	let _toggle_other_field = function() {
		'other' === $select.val()
			? $other.slideDown( 200 )
			: $other.slideUp( 200 );
	};

	$( document ).on( 'ready', _init );

} )( jQuery );

module.exports = delegate_type_fields;